import { UNUSED_PARAMETER } from 'hooks/metrics/shared/constants';
import deleteSymbols from 'utils/deleteSymbols';

export const normalizeHboMetricValue = (value, { slugSpaces = false } = {}) => {
  if (value == null || value === '') return UNUSED_PARAMETER;

  const normalizedValue = deleteSymbols(String(value))
    .toLowerCase()
    .trim()
    .replace(/\s+/g, slugSpaces ? '-' : ' ');

  return normalizedValue || UNUSED_PARAMETER;
};

export const resolveHboMetricSection = ({
  pathname = '',
  selectedNodeText = '',
  selectedNodeCode = '',
  stateSection = '',
}) => {
  if (stateSection) return normalizeHboMetricValue(stateSection);

  const normalizedPath = normalizeHboMetricValue(pathname);

  if (normalizedPath.includes('/help')) return 'centro de ayuda';
  if (normalizedPath.includes('/search')) return 'buscador';
  if (normalizedPath.includes('/watch') || normalizedPath.includes('/live')) {
    return normalizeHboMetricValue(selectedNodeText || 'canales');
  }
  if (
    normalizedPath.includes('/profile') ||
    normalizedPath.includes('/preferences') ||
    normalizedPath.includes('/payment?comefromprofile=true')
  ) {
    return 'configuraciones';
  }
  if (
    normalizedPath.includes('/homeuser') ||
    normalizedPath.includes('/inicio') ||
    normalizedPath.includes('/vcard')
  ) {
    return normalizeHboMetricValue(selectedNodeText || 'inicio');
  }

  return normalizeHboMetricValue(selectedNodeText || selectedNodeCode);
};

export const buildHboModuleName = (...parts) =>
  normalizeHboMetricValue(parts.filter(Boolean).join(' '));

export const buildHboSelectContentValues = ({
  contentSection,
  contentSubsection = UNUSED_PARAMETER,
  contentId = UNUSED_PARAMETER,
  content_id = contentId,
  contentName = UNUSED_PARAMETER,
  content_name = contentName,
  contentType = UNUSED_PARAMETER,
  content_type = contentType,
  contentCategory = UNUSED_PARAMETER,
  content_category = contentCategory,
  contentAvailability = 'por suscripcion',
  content_availability = contentAvailability,
  contentEpisode = UNUSED_PARAMETER,
  content_episode = contentEpisode,
  contentSeason = UNUSED_PARAMETER,
  content_season = contentSeason,
  provider = 'hbo max',
  contentPosition = UNUSED_PARAMETER,
  content_position = contentPosition,
  contentList = UNUSED_PARAMETER,
  content_list = contentList,
  contentListId = UNUSED_PARAMETER,
  content_list_id = contentListId,
  moduloName = UNUSED_PARAMETER,
  interactionType = UNUSED_PARAMETER,
}) => ({
  content_section: contentSection,
  content_subsection: contentSubsection,
  content_id,
  content_name,
  content_type,
  content_category,
  content_availability,
  content_episode,
  content_season,
  provider,
  content_position,
  content_list,
  content_list_id,
  modulo_name: moduloName,
  interaction_type: interactionType,
});

export const buildHboErrorValues = ({
  contentSection,
  contentSubsection = UNUSED_PARAMETER,
  moduloName,
  interactionType,
  errorTitle = 'hbo max',
  errorMessage,
  errorType = 'usuario',
  errorCode = '500',
  provider = 'hbo max',
}) => ({
  content_section: contentSection,
  content_subsection: contentSubsection,
  modulo_name: moduloName,
  interaction_type: interactionType,
  error_title: errorTitle,
  error_message: errorMessage,
  error_type: errorType,
  error_code: errorCode,
  provider,
});
